import {
  OEButton,
  OEModal,
  OEText,
  flex,
  mb,
  mr,
  mt,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { View } from 'react-native';

export interface EmptyClassModalProps {
  isVisible: boolean;
  onConfirmClass: () => void;
  onCancelClass: () => void;
}
export const EmptyClassModal = ({
  isVisible,
  onConfirmClass,
  onCancelClass,
}: EmptyClassModalProps) => {
  return (
    <Container visible={isVisible}>
      <OEText style={mb(12)} fontSize={32} lineHeight={32} fontType="bold">
        Confirm No Students
      </OEText>
      <OEText style={mb(12)} lineHeight={32}>
        Confirm your class is empty
      </OEText>
      <View style={[flex('flex-row', 'justify-content-end'), mt(12)]}>
        <OEButton type="danger" style={mr(12)} onPress={onConfirmClass}>
          Student in Class
        </OEButton>
        <OEButton onPress={onCancelClass}>Class is Empty</OEButton>
      </View>
    </Container>
  );
};

const Container = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;
